import React from "react"
import { Box, Text, HStack, Link as ChakraLink } from "@chakra-ui/react"
import { colours } from "@shared/ui.design-system"
import { space } from "theme/themeConfig"
import { getStaticFile } from "utils/getStaticFile"

type Props = {
  reviewStars: number
  reviewCount: number
  outOfStock: boolean
  showText?: boolean
  reviewLink?: boolean
  textVariant?: "acuminRegularM1" | "bookM2"
}

export const Rating: React.FC<Props> = ({
  reviewStars,
  reviewCount,
  outOfStock,
  showText,
  reviewLink,
  textVariant = "bookM2",
}) => {
  const cssStyles = {
    maxWidth: "100%",
    height: space[1],
    backgroundImage: outOfStock
      ? `url(${getStaticFile("/images/outOfStockReview.svg")})`
      : `url(${getStaticFile("/images/reviewStars.svg")})`,
    backgroundSize: space[1],
  }

  const showLink = (count: number, link?: boolean) => {
    const textConditional = `(${count} Review${count !== 1 ? `s)` : ")"}`
    if (link && count > 0) {
      return (
        <ChakraLink
          variant="bookM2"
          href="#product-reviews-grid"
          title="View Reviews"
        >
          {textConditional}
        </ChakraLink>
      )
    }
    return textConditional
  }

  return (
    <HStack>
      <Box height="16px" width="80px" position="relative">
        <Box
          {...cssStyles}
          width={`${reviewStars * 2 * 10}%`}
          position="relative"
          zIndex="1"
        />
        <Box
          {...cssStyles}
          top="0"
          w="full"
          position="absolute"
          backgroundPosition={`0 ${space[1]}`}
        />
      </Box>

      <Text
        variant={textVariant}
        ml={`${space["-2"]} !important`}
        color={colours.primary.dark}
        fontSize="0.75rem"
        lineHeight="1.125rem"
      >
        {reviewStars && reviewStars.toFixed(1)}
      </Text>

      <Text
        variant={textVariant}
        ml={`${space["-2"]} !important`}
        color={colours.primary.dark}
        textDecoration={showText ? `underline` : ""}
        fontSize="0.75rem"
        lineHeight="1.125rem"
      >
        {showText ? showLink(reviewCount, reviewLink) : `(${reviewCount})`}
      </Text>
    </HStack>
  )
}
